export type TASK_PARAMS_TYPE = {
  page_number?: number
  page_size?: number
  filter?: string
  sort?: string
}

export const defaultTaskParams: TASK_PARAMS_TYPE = {
  page_number: 1,
  page_size: 10,
  filter: 'all',
  sort: '',
}

export const TASK_QUERY_PARAM_TYPE: (keyof TASK_PARAMS_TYPE)[] = [
  'page_number',
  'page_size',
  'filter',
  'sort',
]

export type TASK_PAYLOAD_TYPE = {
  search?: string | null
  planned_date?: any
  assignees?: string[] | null
  priority_statuses?: string[] | null
  statuses?: string[] | null
  style_ids?: string[] | null
  product_description?: string | null
  section_names?: string[] | null
}

export const DEFAULT_TASK_FILTER = {
  search: null,
  planned_date: null,
  assignees: null,
  priority_statuses: null,
  statuses: null,
  style_ids: null,
  product_description: null,
  section_names: null,
}

/**
 * Advance filter sorting
 */
export const TASK_ADVANCE_FILTER_LISTING: (keyof TASK_PAYLOAD_TYPE)[] = [
  'search',
  'planned_date',
  'section_names',
  'assignees',
  'priority_statuses',
  'statuses',
  'style_ids',
  'product_description',
]

export enum PriorityStatus {
  OVERDUE = '1-overdue',
  UPCOMING = '2-upcoming',
  PLANNED = '3-planned',
  DONE = '4-done',
  NOT_PLANNED = '5-not_planned',
}

export const TASK_PRIORITY_STATUS = {
  '1-overdue': 'Overdue',
  '2-upcoming': 'Upcoming',
  '3-planned': 'Planned',
  '4-done': 'Done',
  '5-not_planned': 'Not Planned',
}

export const TASK_STATUSES = {
  approved: 'Approved',
  done: 'Done',
  fail: 'Fail',
  in_progress: 'In Progress',
  'not applicable': 'Not Applicable',
  'not planned': 'Not Planned',
  pass: 'Pass',
  planned: 'Planned',
  planned_date: 'Planned Date',
  rejected: 'Rejected',
  submitted: 'Submitted',
  undefined: 'Undefined',
}

export const TASK_QUERY_KEYS = {
  MYTASK_EXPORT_SETTING: 'MYTASK_EXPORT_SETTING',
}
